'use strict';

bbw.directive.bbwPhotoMontage = ['$window', '$sce', '$parse', 'bbw.LayoutTypeSvc', 'bbw.OffsetCalcSvc', function($window, $sce, $parse, layoutType, offsetCalc) {

    return {
        priority: 100000,
        restrict: 'A',
        scope: true,
        templateUrl: bbw.templateUrl('photo-montage.html'),
        link: function(scope, element, attrs) {
            var montageRows = [];
            var maxWidth = attrs.maxWidth, maxWidthMult = null;
            if (maxWidth) {
                var match = ('' + maxWidth).match(/^(\d+)%$/);
                if (!match) {
                    element.css('maxWidth', '' + maxWidth + 'px');
                } else {
                    maxWidthMult = match[1] / 100;
                    maxWidth = null;
                }
            }
            scope.montage = {};
            if (attrs.onClick) {
                scope.montage.onClick = function(index) {
                    var childScope = scope.$new();
                    childScope.$$index = index;
                    return $parse(attrs.onClick)(childScope);
                }
            }

            var updateMontage = function(photos) {
                montageRows.splice(0, montageRows.length);
                if (angular.isArray(photos) && photos.length) {
                    var rowHeight = attrs.rowHeight || 425;
                    switch (layoutType.getLayoutType()) {
                        case 'mobile':
                            rowHeight *= .5;
                            break;
                        case 'tablet':
                            rowHeight *= .7;
                            break;
                    }
                    var ctWidth = element[0].clientWidth * (maxWidthMult || .9);
                    if (maxWidth && ctWidth > maxWidth) {
                        ctWidth = maxWidth;
                    }
                    var singlePhoto = (photos.length == 1);
                    if (singlePhoto) {
                        rowHeight *= 1.5;
                    }
                    var rowsCnt = Math.ceil(photos.length / 2);
                    var rowStep = Math.ceil(photos.length / rowsCnt);
                    for (var i = 0; i < photos.length; ++i) {
                        var rowIndex = Math.floor(i / rowStep);
                        var photo = photos[i];
                        var montageUrl = photo.extra_montage_url;
                        var fullUrl = photo.full_url;
                        if (!montageUrl) {
                            montageUrl = fullUrl;
                        }
                        var grow = Math.round(fullUrl.size.width / fullUrl.size.height * rowHeight);
                        if (montageRows.length <= rowIndex) {
                            montageRows[rowIndex] = {
                                width: ctWidth,
                                height: rowHeight,
                                cols: []
                            }
                        }
                        //noinspection JSUnresolvedFunction
                        montageRows[rowIndex].cols.push({
                            photo: photo,
                            index: i,
                            singlePhoto: singlePhoto,
                            url: $sce.trustAsResourceUrl(montageUrl.href),
                            grow: grow,
                            isIntimate: photo.as_intimate,
                            maxWidth: singlePhoto ? '' + grow + 'px' : 'auto'
                        });
                    }
                    element.css('height', '' + montageRows.length * rowHeight + 'px');
                } else {
                    element.css('height', '0');
                }
                addScrollListener();
                checkVisibility();
            };
            var updateTimeout;
            var cancel = function() {
                if (updateTimeout) {
                    clearTimeout(updateTimeout);
                    updateTimeout = undefined;
                }
            };
            var width;
            var update = function(timeout, apply, fromResize) {
                var newWidth = document.documentElement.clientWidth;
                var isWidthChanged = true;
                if (angular.isDefined(width) && Math.abs(width - newWidth) < 3) {
                    isWidthChanged = false;
                }
                width = newWidth;
                cancel();
                if (fromResize && !isWidthChanged) {
                    return;
                }
                setTimeout(function() {
                    updateMontage(scope.$eval(attrs.bbwPhotoMontage));
                    if (apply !== false) {
                        scope.$safeApply();
                    }
                }, timeout);
            };
            var updateFromResize = function() {
                update(0, true, true);
            };
            scope.status = {};
            var isFirstUpdate = true;
            scope.$watchCollection(attrs.bbwPhotoMontage, function() {
                update(0, isFirstUpdate);
                isFirstUpdate = false;
            });
            var getScrollTop = function() {
                return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
            };
            var getScrollHeight = function() {
                return (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight);
            };
            var isInVisibleArea = function(gapPercent) {
                var scrollTop = Math.max(0, getScrollTop()),
                    scrollHeight = Math.max(300, getScrollHeight()),
                    top = offsetCalc.top(element);
                gapPercent = gapPercent || 40;
                var minTop = scrollTop + scrollHeight * ((100 + gapPercent) / 100);
                return top < minTop;
            };
            var addScrollListener, removeScrollListener;
            var commit = function() {
                scope.status.ready = true;
                scope.status.waiting = false;
                removeScrollListener();
                scope.$safeApply();
                return true;
            };
            var checkVisibility = function() {
                if (scope.status.ready)  {
                    commit();
                    return true;
                }
                if (isInVisibleArea()) {
                    scope.montage.rows = montageRows;
                    commit();
                    return true;
                } else {
                    scope.status.waiting = true;
                    return false;
                }
            };
            addScrollListener = function() {
                $window.addEventListener('scroll', checkVisibility);
            };
            removeScrollListener = function() {
                $window.removeEventListener('scroll', checkVisibility);
            };
            $window.addEventListener('resize', updateFromResize);
            var destroyed, destroy = function () {
                if (!destroyed) {
                    destroyed = true;
                    cancel();
                    $window.removeEventListener('resize', updateFromResize);
                    if (scope.status.waiting && !scope.status.ready) {
                        removeScrollListener();
                    }
                }
            };
            scope.$on('$destroy', destroy);
            element.on('$destroy', destroy);
        }
    };
}];
